import DevicesActivate from './DevicesActivate'

export default DevicesActivate
